import { Controller } from "@hotwired/stimulus"

// Monthly/annual toggle for the billing pricing table. Buttons carry
// data-interval="monthly|annual"; price blocks carry data-billing-interval-
// target="price" with data-interval matching the one they belong to.
export default class extends Controller {
  static targets = ["toggle", "price"]
  static values = { interval: { type: String, default: "monthly" } }

  connect() {
    this.apply(this.intervalValue)
  }

  select(event) {
    this.apply(event.currentTarget.dataset.interval)
  }

  apply(interval) {
    this.intervalValue = interval

    this.toggleTargets.forEach((btn) => {
      const active = btn.dataset.interval === interval
      btn.classList.toggle("bg-white", active)
      btn.classList.toggle("text-primary-700", active)
      btn.classList.toggle("shadow-card", active)
      btn.classList.toggle("text-gray-500", !active)
    })

    this.priceTargets.forEach((price) => {
      price.classList.toggle("hidden", price.dataset.interval !== interval)
    })
  }
}
